import React from "react";
import { Progress, InfiniteScroll, printComponent } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import BaseListPage from "../../../../../base/BaseListPage";
import Table from "../../../../../components/Table";
import ViewListOfEmployeePresenter from "./ViewListOfEmployeePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import PrintCommendationCer from "./PrintCommendationCer";
import { renderToStaticMarkup } from "react-dom/server";

export default class ViewListOfEmployee extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ViewListOfEmployeePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
      printData: {},
      employee: {},
    };
    this.contractPDF = React.createRef();
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "commendation_list";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handleViewData(id) {
    this.props.onViewData(id.id);
  }

  async handleEditData(objectID) {
    const commendation = await findObjectUseCase().execute(
      "commendation_list",
      { where: { id: objectID } }
    );
    // const commendation = list.find((data) => data.id === objectID);
    this.props.onReceiveData(commendation[0]);
  }
  handleDelete(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }
  async printData(data) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;

    const printContentElement = PrintCommendationCer({
      object: this.props.source,
      commendation: data,
    });
    const printContentHTML = renderToStaticMarkup(printContentElement);

    iframeDoc.open();
    iframeDoc.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Print Document</title>
      <style>
        @media print {
          @page {
            margin: 0;
            size: auto;
          }
          body {
            margin: 0;
            padding: 0;
          }
          * {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
        }
        body {
          margin: 0;
          padding: 0;
          font-family: Arial, sans-serif;
        }
      </style>
    </head>
    <body>
  `);
    iframeDoc.write("<div>");
    iframeDoc.write("<div>");
    iframeDoc.write(printContentHTML);
    iframeDoc.write("</div>");
    iframeDoc.write("</div>");
    iframeDoc.write("</body></html>");
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  source() {
    return this.props.source;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit, loading } = this.state;
    // console.log("source: ", this.props.source);
    if (!schema) return <Progress />;
    return (
      <>
        <div>
          {/* <div className="d-none2">
            <div ref={this.contractPDF} id="contractPDF">
              <PrintCommendationCer
                object={this.props.source}
                commendation={this.state.printData}
              />
            </div>
          </div> */}
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <Table
              viewObject={this.handleViewData.bind(this)}
              editId={this.handleEditData.bind(this)}
              objectId={this.handleDelete.bind(this)}
              generateLeaveCard={this.printData.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              actionsList={[
                {
                  label: (
                    <b>
                      <i className="bi bi-search"> View</i>
                    </b>
                  ),
                  actionType: "MDS",
                },
                // {
                //   label: (
                //     <b>
                //       <i className="bi bi-pencil-square"> Edit</i>
                //     </b>
                //   ),
                //   actionType: "object",
                // },
              ]}
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                ["id", "Created At", "Updated At", "employeeID"]
              )}
              onClickItem={this.onClickItem.bind(this)}
            />
          </InfiniteScroll>
        </div>
      </>
    );
  }
}
